import React from 'react';
import {IntlProvider, FormattedMessage, useIntl} from 'react-intl';

import {
  Form,
  FormGroup,
  FormField,
  Dropdown,
  Button,
  Icon,
  Input,
  TextArea,
  Radio
} from 'semantic-ui-react'
import {
  DateTextBox
} from 'react-lib/apps/common'
import {
  Table
} from 'react-lib/frameworks/Table'

const CardCourseListUX = (props: any) => {
    return(
      <div
        style={{padding: "10px"}}>
        <Form
          className="small"
          id="CardEmployeeSummaryWorkHourUX-Form-1">
          <FormGroup
            id="CardEmployeeSummaryWorkHourUX-FormGroup-2"
            inline={true}>
            <FormField
              id="CardEmployeeSummaryWorkHourUX-FormField-6"
              inline={true}
              width={4}>
              <label
                id="CardEmployeeSummaryWorkHourUX-label-7"
                style={{minWidth: "max-content"}}>
                {props.languageUX === "en" ? "Search Course :" : "ค้นหาหลักสูตร :"}
              </label>
              <Input
                fluid={true}
                icon="search"
                id="CardCourseListUX-Input-137"
                name="course_name_id"
                onChange={props.onChangeFilter}
                value={props.filter?.course_name_id ?? ""}>
              </Input>
            </FormField>
            <FormField
              id="CardEmployeeTimeAttendanceUX-FormField-20"
              inline={true}
              width={3}>
              <label
                id="CardEmployeeTimeAttendanceUX-label-28"
                style={{minWidth: "max-content"}}>
                {props.languageUX === "en" ? "Type :" : "พิมพ์ :"}
              </label>
              <Dropdown
                clearable={true}
                fluid={true}
                id="CardEmployeeTimeAttendanceUX-Dropdown-27"
                name="training_type"
                onChange={props.onChangeFilter}
                options={props.typeOptions}
                search={true}
                selection={true}
                style={{width: "100%"}}
                value={props.filter?.training_type?? ""}>
              </Dropdown>
            </FormField>
            <FormField
              id="CardEmployeeTimeAttendanceUX-FormField-21"
              inline={true}
              width={3}>
              <label
                id="CardEmployeeTimeAttendanceUX-label-33"
                style={{minWidth: "max-content"}}>
                {props.languageUX === "en" ? "Start date :" : "วันที่เริ่มต้น :"}
              </label>
              <div
                id="CardEmployeeTimeAttendanceUX-div-29"
                style={{width: "100%"}}>

                <DateTextBox
                  id="CardEmployeeTimeAttendanceUX-DateTextBox-31"
                  onChange={(value: any)=>props.onChangeFilter?.(null,{name: "start_date", value})}
                  value={props.filter?.start_date}>
                </DateTextBox>
              </div>
            </FormField>
            <FormField
              id="CardEmployeeTimeAttendanceUX-FormField-22"
              inline={true}
              width={3}>
              <label
                id="CardEmployeeTimeAttendanceUX-label-34"
                style={{minWidth: "max-content"}}>
                {props.languageUX === "en" ? "Expiry date :" : "วันหมดอายุ :"}
              </label>
              <div
                id="CardEmployeeTimeAttendanceUX-div-30"
                style={{width: "100%"}}>

                <DateTextBox
                  id="CardEmployeeTimeAttendanceUX-DateTextBox-32"
                  onChange={(value: any)=>props.onChangeFilter?.(null,{name: "expiry_date", value})}
                  value={props.filter?.expiry_date}>
                </DateTextBox>
              </div>
            </FormField>
            <FormField
              id="CardCourseListUX-FormField-41"
              inline={true}
              width={4}>
              <label
                id="CardCourseListUX-label-42"
                style={{minWidth: "max-content"}}>
                {props.languageUX === "en" ? "Status :" : "สถานะ :"}
              </label>
              <div
                id="CardCourseListUX-div-43"
                style={{width: "100%"}}>
                {props.statusFilter}
              </div>
            </FormField>
            <FormField
              id="CardEmployeeSummaryWorkHourUX-FormField-12"
              inline={true}
              style={{paddingRight: "0.5rem"}}>
              <div
                id="CardEmployeeSummaryWorkHourUX-div-13">
                {props.buttonSearch}
              </div>
            </FormField>
            <FormField
              id="CardEmployeeTimeAttendanceUX-FormField-23"
              inline={true}
              style={{paddingRight: "0.5rem"}}>
              <div
                id="CardCourseListUX-div-44">
                {props.buttonPrint}
              </div>
            </FormField>
            <FormField
              id="CardEmployeeTimeAttendanceUX-FormField-25"
              inline={true}
              style={{paddingRight: "0"}}>
              <Button
                color="green"
                icon={true}
                id="CardEmployeeTimeAttendanceUX-Button-35"
                onClick={props.onClickNewCourse}
                size="small"
                style={{minWidth: "max-content", display: props.hideNewCourse?"none":""}}>
                <Icon
                  id="CardEmployeeTimeAttendanceUX-Icon-36"
                  name="plus">
                </Icon>
                <label
                  id="CardEmployeeTimeAttendanceUX-label-37"
                  style={{marginLeft: "6px"}}>
                  {props.languageUX === "en" ? "New Course" : "หลักสูตรใหม่"}
                </label>
              </Button>
            </FormField>
          </FormGroup>
        </Form>
        <div
          id="CardEmployeeSummaryWorkHourUX-div-15"
          style={{width: "100%"}}>
          {}
          <Table
            data={props.tableData}
            getTrProps={props.getTrProps}
            headers="ID,Course Subject,Type,Pricing (Baht),Course period (hr),No. of participant,Start date,Expiry date,Status,Created"
            id="CardEmployeeTimeAttendanceUX-Table-39"
            keys="id,title,typeName,pricing,course_period,participants_count,startDate,expiryDate,statusName,created"
            minRows={props.detail?3:14}
            showPagination={false}
            sortable={false}
            style={{height: props.detail?"calc(100vh - 34rem)":"calc(100vh - 12.5rem)"}}
            widths="^50,^200,^70,^80,^100,^110,^75,^75,^75,^120">
          </Table>
        </div>
        <div
          id="CardCourseListUX-div-46"
          style={{display: props.detail? "" : "none"}}>

          <div
            id="CardCourseListUX-div-47"
            style={{color: "rgba(33, 133, 208, 1)", fontWeight: "bold", margin: "1.5rem 0 1rem"}}>
            {props.detail?.id?props.detail?.subject:"New Course"}
          </div>
          <Form
            className="--override-disabled --grey"
            id="CardCourseListUX-Form-48">
            <FormGroup
              id="CardCourseListUX-FormGroup-49"
              inline={true}>
              <FormField
                className={`required ${props.showRequiredField?.subject? "error" : ""}`}
                id="CardCourseListUX-FormField-52"
                inline={true}
                style={{position: "relative"}}
                width={8}>
                <label
                  id="CardCourseListUX-label-61"
                  style={{minWidth: "50px"}}>
                  {props.languageUX === "en" ? "Title :" : "ชื่อ :"}
                </label>
                <Input
                  fluid={true}
                  id="CardCourseListUX-Input-62"
                  name="subject"
                  onChange={props.onChangeValue}
                  readOnly={props.readOnly}
                  value={props.detail?.subject?? ""}>
                </Input>
                <div
                  id="CardCourseListUX-div-131"
                  style={{position: "absolute", bottom: "-16px", color: "red", fontSize: "0.75rem", right: "15px"}}>
                  {props.showRequiredField?.subject|| ""}
                </div>
              </FormField>
              <FormField
                id="CardCourseListUX-FormField-145"
                style={{minWidth: "3rem"}}>
              </FormField>
              <FormField
                id="CardCourseListUX-FormField-142"
                inline={true}
                width={8}>
                <label
                  id="CardCourseListUX-label-143"
                  style={{minWidth: "50px"}}>
                  หัวข้อ
                </label>
                <Input
                  fluid={true}
                  id="CardCourseListUX-Input-144"
                  name="subject_th"
                  onChange={props.onChangeValue}
                  readOnly={props.readOnly}
                  value={props.detail?.subject_th?? ""}>
                </Input>
              </FormField>
            </FormGroup>
            <FormGroup
              id="CardCourseListUX-FormGroup-50"
              inline={true}>
              <FormField
                className={`required ${props.showRequiredField?.training_type? "error" : ""}`}
                id="CardCourseListUX-FormField-53"
                inline={true}
                style={{position: "relative"}}
                width={4}>
                <label
                  id="CardCourseListUX-label-60"
                  style={{minWidth: "50px"}}>
                  {props.languageUX === "en" ? "Type :" : "พิมพ์ :"}
                </label>
                <Dropdown
                  disabled={props.readOnly}
                  fluid={true}
                  id="CardCourseListUX-Dropdown-65"
                  name="training_type"
                  onChange={props.onChangeValue}
                  options={props.typeOptions}
                  search={true}
                  selection={true}
                  style={{width: "100%"}}
                  value={props.detail?.training_type?? ""}>
                </Dropdown>
                <div
                  id="CardCourseListUX-div-132"
                  style={{position: "absolute", bottom: "-16px", color: "red", fontSize: "0.75rem", right: "15px"}}>
                  {props.showRequiredField?.training_type|| ""}
                </div>
              </FormField>
              <FormField
                className={`required ${props.showRequiredField?.pricing? "error" : ""}`}
                id="CardCourseListUX-FormField-54"
                inline={true}
                style={{position: "relative"}}
                width={3}>
                <label
                  id="CardCourseListUX-label-59"
                  style={{minWidth: "max-content"}}>
                  {props.languageUX === "en" ? "Pricing :" : "ราคา :"}
                </label>
                <Input
                  fluid={true}
                  id="CardCourseListUX-Input-64"
                  name="pricing"
                  onChange={props.onChangeValue}
                  readOnly={props.readOnly}
                  value={props.detail?.pricing?? ""}>
                </Input>
                <div
                  id="CardCourseListUX-div-133"
                  style={{position: "absolute", bottom: "-16px", color: "red", fontSize: "0.75rem", right: "15px"}}>
                  {props.showRequiredField?.pricing|| ""}
                </div>
              </FormField>
              <FormField
                id="CardCourseListUX-FormField-55"
                inline={true}>
                <label
                  id="CardCourseListUX-label-58">
                  {props.languageUX === "en" ? "Baht" : "บาท"}
                </label>
              </FormField>
            </FormGroup>
            <FormGroup
              id="CardCourseListUX-FormGroup-51"
              inline={true}>
              <FormField
                id="CardCourseListUX-FormField-56"
                inline={true}
                width={8}>
                <label
                  id="CardCourseListUX-label-57"
                  style={{minWidth: "50px"}}>
                  {props.languageUX === "en" ? "Venue :" : "สถานที่ :"}
                </label>
                <Input
                  disabled={props.readOnly}
                  fluid={true}
                  id="CardCourseListUX-Input-63"
                  name="venue"
                  onChange={props.onChangeValue}
                  value={props.detail?.venue?? ""}>
                </Input>
              </FormField>
              <FormField
                id="CardCourseListUX-FormField-146"
                style={{minWidth: "3rem"}}>
              </FormField>
              <FormField
                id="CardCourseListUX-FormField-147"
                inline={true}
                width={8}>
                <label
                  id="CardCourseListUX-label-148"
                  style={{minWidth: "50px"}}>
                  สถานที่ :
                </label>
                <Input
                  disabled={props.readOnly}
                  fluid={true}
                  id="CardCourseListUX-Input-149"
                  name="venue_th"
                  onChange={props.onChangeValue}
                  value={props.detail?.venue_th?? ""}>
                </Input>
              </FormField>
            </FormGroup>
            <FormGroup
              id="CardCourseListUX-FormGroup-66">
              <FormField
                id="CardCourseListUX-FormField-67"
                width={8}>
                <label
                  id="CardCourseListUX-label-68">
                  {props.languageUX === "en" ? "Description" : "คำอธิบาย"}
                </label>
                <TextArea
                  id="CardCourseListUX-TextArea-69"
                  name="description"
                  onChange={props.onChangeValue}
                  readOnly={props.readOnly}
                  rows={5}
                  value={props.detail?.description?? ""}>
                </TextArea>
              </FormField>
              <FormField
                id="CardCourseListUX-FormField-150"
                style={{minWidth: "3rem"}}>
              </FormField>
              <FormField
                id="CardCourseListUX-FormField-151"
                style={{paddingLeft: "0", paddingRight: "1.5rem"}}
                width={8}>
                <label
                  id="CardCourseListUX-label-152">
                  คำอธิบาย
                </label>
                <TextArea
                  id="CardCourseListUX-TextArea-153"
                  name="description_th"
                  onChange={props.onChangeValue}
                  readOnly={props.readOnly}
                  rows="5"
                  value={props.detail?.description_th?? ""}>
                </TextArea>
              </FormField>
            </FormGroup>
            <FormGroup
              id="CardCourseListUX-FormGroup-70"
              inline={true}>
              <FormField
                id="CardCourseListUX-FormField-71"
                inline={true}
                width={6}>
                <label
                  id="CardCourseListUX-label-73">
                  Attachments:
                </label>
                <Input
                  fluid={true}
                  id="CardCourseListUX-Input-74"
                  onChange={props.onChangeLink}
                  placeholder="Enter URL (Photo, YouTube, PDF, or webpage)"
                  readOnly={props.readOnly}
                  value={props.link ?? ""}>
                </Input>
              </FormField>
              <FormField
                id="CardCourseListUX-FormField-72">
                <Button
                  color="green"
                  disabled={!props.link}
                  id="CardCourseListUX-Button-75"
                  onClick={props.onAddLink}>
                  {props.languageUX === "en" ? "ADD LINK" : "เพิ่มลิงค์"}
                </Button>
              </FormField>
            </FormGroup>
            <FormGroup
              id="CardCourseListUX-FormGroup-76"
              style={{marginBottom: 0}}>
              <div
                className="field"
                id="CardCourseListUX-div-127"
                style={{width: "100%"}}>
                {props.attachmentList}
              </div>
            </FormGroup>
            <FormGroup
              id="CardCourseListUX-FormGroup-77"
              inline={true}>
              <FormField
                className={`required ${props.showRequiredField?.start_date? "error" : ""}`}
                id="CardCourseListUX-FormField-78"
                inline={true}
                style={{position: "relative"}}
                width={3}>
                <label
                  id="CardCourseListUX-label-90"
                  style={{minWidth: "max-content"}}>
                  {props.languageUX === "en" ? "Start date :" : "วันที่เริ่มต้น :"}
                </label>
                <div
                  id="CardCourseListUX-div-96"
                  style={{width: "100%"}}>

                  <DateTextBox
                    disabled={props.readOnly}
                    id="CardCourseListUX-DateTextBox-98"
                    onChange={(value: any)=>props.onChangeValue?.(null, {name:"start_date", value})}
                    style={{color: "rgba(0,0,0,.87)"}}
                    value={props.detail?.start_date?? ""}>
                  </DateTextBox>
                </div>
                <div
                  id="CardCourseListUX-div-134"
                  style={{position: "absolute", bottom: "-16px", color: "red", fontSize: "0.75rem", right: "15px"}}>
                  {props.showRequiredField?.start_date|| ""}
                </div>
              </FormField>
              <FormField
                className={`${props.showRequiredField?.start_time? "error" : ""}`}
                id="CardCourseListUX-FormField-79"
                inline={true}
                style={{position: "relative"}}
                width={3}>
                <label
                  id="CardCourseListUX-label-91"
                  style={{minWidth: "max-content"}}>
                  {props.languageUX === "en" ? "Start time :" : "เวลาเริ่มต้น :"}
                </label>
                <div
                  id="CardCourseListUX-div-100"
                  style={{width: "100%"}}>
                  {props.startTime}
                </div>
                <div
                  id="CardCourseListUX-div-139"
                  style={{position: "absolute", bottom: "-16px", color: "red", fontSize: "0.75rem", right: "15px"}}>
                  {props.showRequiredField?.start_time|| ""}
                </div>
              </FormField>
              <FormField
                className={`required ${props.showRequiredField?.end_date? "error" : ""}`}
                id="CardCourseListUX-FormField-80"
                inline={true}
                style={{position: "relative"}}
                width={3}>
                <label
                  id="CardCourseListUX-label-92"
                  style={{minWidth: "max-content"}}>
                  {props.languageUX === "en" ? "End date :" : "วันที่สิ้นสุด :"}
                </label>
                <div
                  id="CardCourseListUX-div-97"
                  style={{width: "100%"}}>

                  <DateTextBox
                    disabled={props.readOnly}
                    id="CardCourseListUX-DateTextBox-99"
                    onChange={(value: any)=>props.onChangeValue?.(null, {name:"end_date", value})}
                    style={{color: "rgba(0,0,0,.87)"}}
                    value={props.detail?.end_date?? ""}>
                  </DateTextBox>
                </div>
                <div
                  id="CardCourseListUX-div-135"
                  style={{position: "absolute", bottom: "-16px", color: "red", fontSize: "0.75rem", right: "15px"}}>
                  {props.showRequiredField?.end_date|| ""}
                </div>
              </FormField>
              <FormField
                className={`${props.showRequiredField?.end_time? "error" : ""}`}
                id="CardCourseListUX-FormField-81"
                inline={true}
                style={{position: "relative"}}
                width={3}>
                <label
                  id="CardCourseListUX-label-93"
                  style={{minWidth: "max-content"}}>
                  {props.languageUX === "en" ? "End time :" : "เวลาสิ้นสุด :"}
                </label>
                <div
                  id="CardCourseListUX-div-101"
                  style={{width: "100%"}}>
                  {props.endTime}
                </div>
                <div
                  id="CardCourseListUX-div-138"
                  style={{position: "absolute", bottom: "-16px", color: "red", fontSize: "0.75rem", right: "15px"}}>
                  {props.showRequiredField?.end_time|| ""}
                </div>
              </FormField>
              <FormField
                className={`required ${props.showRequiredField?.course_period? "error" : ""}`}
                id="CardCourseListUX-FormField-82"
                inline={true}
                style={{position: "relative"}}
                width={2}>
                <label
                  id="CardCourseListUX-label-94"
                  style={{minWidth: "max-content"}}>
                  {props.languageUX === "en" ? "Course period" : "ระยะเวลาหลักสูตร"}
                </label>
                <Input
                  fluid={true}
                  id="CardCourseListUX-Input-105"
                  name="course_period"
                  onChange={props.onChangeValue}
                  readOnly={props.readOnly}
                  style={{minWidth: "5rem"}}
                  value={props.detail?.course_period?? ""}>
                </Input>
                <div
                  id="CardCourseListUX-div-136"
                  style={{position: "absolute", bottom: "-16px", color: "red", fontSize: "0.75rem", right: "0"}}>
                  {props.showRequiredField?.course_period|| ""}
                </div>
              </FormField>
              <FormField
                id="CardCourseListUX-FormField-83"
                inline={true}>
                <label
                  id="CardCourseListUX-label-95"
                  style={{paddingLeft: "1rem"}}>
                  {props.languageUX === "en" ? "hr" : "ชั่วโมง"}
                </label>
              </FormField>
            </FormGroup>
            <FormGroup
              id="CardCourseListUX-FormGroup-84"
              inline={true}>
              <FormField
                className={`required ${props.showRequiredField?.expiry_date? "error" : ""}`}
                id="CardCourseListUX-FormField-85"
                inline={true}
                style={{position: "relative"}}
                width={3}>
                <label
                  id="CardCourseListUX-label-102"
                  style={{minWidth: "max-content"}}>
                  {props.languageUX === "en" ? "Expiry date :" : "วันหมดอายุ :"}
                </label>
                <div
                  id="CardCourseListUX-div-103"
                  style={{width: "100%"}}>

                  <DateTextBox
                    disabled={!props.enabledExpiryDate || props.readOnly}
                    id="CardCourseListUX-DateTextBox-104"
                    onChange={(value: any)=>props.onChangeValue?.(null, {name:"expiry_date", value})}
                    style={{color: "rgba(0,0,0,.87)"}}
                    value={props.detail?.expiry_date??""}>
                  </DateTextBox>
                </div>
                <div
                  id="CardCourseListUX-div-141"
                  style={{position: "absolute", bottom: "-16px", color: "red", fontSize: "0.75rem", right: "15px"}}>
                  {props.showRequiredField?.expiry_date|| ""}
                </div>
              </FormField>
            </FormGroup>
            <FormGroup
              id="CardCourseListUX-FormGroup-86"
              inline={true}>
              <FormField
                id="CardCourseListUX-FormField-106"
                inline={true}>
                <label
                  id="CardCourseListUX-label-108">
                  {props.languageUX === "en" ? "Evaluation" : "การประเมิน"}
                </label>
              </FormField>
              <FormField
                id="CardCourseListUX-FormField-107"
                inline={true}>
                <Button
                  color="green"
                  disabled={props.readOnly}
                  icon="plus"
                  id="CardCourseListUX-Button-109"
                  onClick={props.onAddEvaluation}
                  size="mini"
                  style={{fontSize: "0.55rem"}}>
                </Button>
              </FormField>
            </FormGroup>
            <FormGroup
              id="CardCourseListUX-FormGroup-87"
              style={{marginBottom: "0"}}>
              <div
                className="field"
                id="CardCourseListUX-div-125"
                style={{width: "100%"}}>
                {props.evaluationList}
              </div>
            </FormGroup>
            <FormGroup
              id="CardCourseListUX-FormGroup-157"
              inline={true}>
              <FormField
                id="CardCourseListUX-FormField-158"
                inline={true}
                width={1}>
                <label
                  id="CardCourseListUX-label-162">
                  {props.languageUX === "en" ? "Participant:" : "ผู้เข้าร่วม:"}
                </label>
              </FormField>
              <FormField
                id="CardCourseListUX-FormField-164"
                inline={true}
                width={2}>
                <Radio
                  checked={props.detail?.participant === "employee"}
                  id="CardCourseListUX-Radio-167"
                  label={props.languageUX === "en" ? "Select Employee" : "Select Employee"}
                  name="participant"
                  onChange={props.onChangeValue}
                  value="employee">
                </Radio>
              </FormField>
              <FormField
                id="CardCourseListUX-FormField-159"
                inline={true}
                width={6}>
                <div
                  id="CardCourseListUX-div-163"
                  style={{width: "100%"}}>
                  {props.employeeSearchBox}
                </div>
              </FormField>
            </FormGroup>
            <FormGroup
              id="CardCourseListUX-FormGroup-88"
              inline={true}>
              <FormField
                id="CardCourseListUX-FormField-160"
                inline={true}
                width={1}>
              </FormField>
              <FormField
                id="CardCourseListUX-FormField-165"
                inline={true}
                width={2}>
                <Radio
                  checked={props.detail?.participant === "department"}
                  id="CardCourseListUX-Radio-166"
                  label={props.languageUX === "en" ? "Select Department" : "Select Department"}
                  name="participant"
                  onChange={props.onChangeValue}
                  value="department">
                </Radio>
              </FormField>
              <FormField
                id="CardCourseListUX-FormField-110"
                inline={true}
                width={6}>
                <Dropdown
                  disabled={!props.enabledParticipant || props.detail?.participant !== "department"}
                  fluid={true}
                  id="CardCourseListUX-Dropdown-168"
                  name="division"
                  onChange={props.onChangeValue}
                  options={props.divisionOptions}
                  placeholder="Select Department"
                  search={true}
                  selection={true}
                  style={{width: "100%"}}
                  value={props.detail?.division ?? ""}>
                </Dropdown>
              </FormField>
              <FormField
                id="CardCourseListUX-FormField-111"
                inline={true}>
                <div
                  id="CardCourseListUX-div-169">
                  {props.buttonAdd}
                </div>
              </FormField>
            </FormGroup>
            <FormGroup
              id="CardCourseListUX-FormGroup-89"
              style={{marginBottom: "0"}}>
              <div
                className="field"
                id="CardCourseListUX-div-126"
                style={{width: "100%"}}>
                {props.participantList}
              </div>
            </FormGroup>
            <FormGroup
              id="CardCourseListUX-FormGroup-115"
              inline={true}>
              <FormField
                id="CardCourseListUX-FormField-116"
                inline={true}>
                <label
                  id="CardCourseListUX-label-117"
                  style={{fontWeight: "normal"}}>
                  {`Total participant :  ${props.totalParticipant ?? "0"}`}
                </label>
              </FormField>
            </FormGroup>
            <FormGroup
              id="CardCourseListUX-FormGroup-118"
              inline={true}>
              <FormField
                id="CardCourseListUX-FormField-119"
                inline={true}
                style={{flex:1}}>
              </FormField>
              <FormField
                id="CardCourseListUX-FormField-120"
                inline={true}>
                <Button
                  color="green"
                  id="CardCourseListUX-Button-130"
                  onClick={props.onSave}
                  size="small">
                  {props.languageUX === "en" ? "SAVE" : "บันทึก"}
                </Button>
              </FormField>
              <FormField
                id="CardCourseListUX-FormField-128"
                style={{display: props.detail?.id && !props.hideDeleteCourse?"":"none"}}>
                <Button
                  color="red"
                  disabled={props.detail?.is_approved??false}
                  id="CardCourseListUX-Button-129"
                  onClick={props.onDelete}
                  size="small">
                  {props.languageUX === "en" ? "Delete Course" : "ลบหลักสูตร"}
                </Button>
              </FormField>
              <FormField
                id="CardCourseListUX-FormField-154">
                <div
                  id="CardCourseListUX-div-156">
                  {props.buttonActive}
                </div>
              </FormField>
              <FormField
                id="CardCourseListUX-FormField-121"
                inline={true}>
                <Button
                  color="red"
                  id="CardCourseListUX-Button-123"
                  onClick={props.onClickCancel}
                  size="small">
                  {props.languageUX === "en" ? "CANCEL" : "ยกเลิก"}
                </Button>
              </FormField>
            </FormGroup>
          </Form>
        </div>
      </div>
    )
}


export default CardCourseListUX

export const screenPropsDefault = {"cannotPay":false,"cashAmountText":"14","citizenID":"31020000552","oweText":123,"patientNameAndHN":"HN: xxxxx นายทดสอบ","sumAmount":{"price":100,"reimbursable":42}}

/* Date Time : Thu Sep 25 2025 10:32:11 GMT+0700 (Indochina Time)
/* Original screen Data ************************************************************

{
  "elements": [
    {
      "id": 0,
      "name": "div",
      "parent": -1,
      "props": {
        "id": {
          "type": "value",
          "value": ""
        },
        "style": {
          "type": "code",
          "value": "{padding: \"10px\"}"
        }
      },
      "seq": 0
    },
    {
      "from": "semantic-ui-react",
      "id": 1,
      "name": "Form",
      "parent": 0,
      "props": {
        "className": {
          "type": "value",
          "value": "small"
        },
        "id": {
          "type": "value",
          "value": "CardEmployeeSummaryWorkHourUX-Form-1"
        }
      },
      "seq": 1,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 2,
      "name": "FormGroup",
      "parent": 1,
      "props": {
        "id": {
          "type": "value",
          "value": "CardEmployeeSummaryWorkHourUX-FormGroup-2"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 2,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 6,
      "name": "FormField",
      "parent": 2,
      "props": {
        "id": {
          "type": "value",
          "value": "CardEmployeeSummaryWorkHourUX-FormField-6"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "4"
        }
      },
      "seq": 6,
      "void": false
    },
    {
      "from": null,
      "id": 7,
      "name": "label",
      "parent": 6,
      "props": {
        "children": {
          "type": "value",
          "value": "ค้นหาหลักสูตร :",
          "valueEN": "Search Course :"
        },
        "id": {
          "type": "value",
          "value": "CardEmployeeSummaryWorkHourUX-label-7"
        },
        "style": {
          "type": "code",
          "value": "{minWidth: \"max-content\"}"
        }
      },
      "seq": 7,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 12,
      "name": "FormField",
      "parent": 2,
      "props": {
        "id": {
          "type": "value",
          "value": "CardEmployeeSummaryWorkHourUX-FormField-12"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{paddingRight: \"0.5rem\"}"
        },
        "width": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 23,
      "void": false
    },
    {
      "from": null,
      "id": 13,
      "name": "div",
      "parent": 12,
      "props": {
        "children": {
          "type": "code",
          "value": "props.buttonSearch"
        },
        "id": {
          "type": "value",
          "value": "CardEmployeeSummaryWorkHourUX-div-13"
        }
      },
      "seq": 14,
      "void": false
    },
    {
      "from": null,
      "id": 15,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "code",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardEmployeeSummaryWorkHourUX-div-15"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        }
      },
      "seq": 15,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 20,
      "name": "FormField",
      "parent": 2,
      "props": {
        "id": {
          "type": "value",
          "value": "CardEmployeeTimeAttendanceUX-FormField-20"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "3"
        }
      },
      "seq": 12,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 21,
      "name": "FormField",
      "parent": 2,
      "props": {
        "id": {
          "type": "value",
          "value": "CardEmployeeTimeAttendanceUX-FormField-21"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "3"
        }
      },
      "seq": 20,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 22,
      "name": "FormField",
      "parent": 2,
      "props": {
        "id": {
          "type": "value",
          "value": "CardEmployeeTimeAttendanceUX-FormField-22"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "3"
        }
      },
      "seq": 21,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 23,
      "name": "FormField",
      "parent": 2,
      "props": {
        "id": {
          "type": "value",
          "value": "CardEmployeeTimeAttendanceUX-FormField-23"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{paddingRight: \"0.5rem\"}"
        },
        "width": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 25,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 25,
      "name": "FormField",
      "parent": 2,
      "props": {
        "id": {
          "type": "value",
          "value": "CardEmployeeTimeAttendanceUX-FormField-25"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{paddingRight: \"0\"}"
        },
        "width": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 41,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 27,
      "name": "Dropdown",
      "parent": 20,
      "props": {
        "clearable": {
          "type": "code",
          "value": "true"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardEmployeeTimeAttendanceUX-Dropdown-27"
        },
        "name": {
          "type": "value",
          "value": "training_type"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeFilter"
        },
        "options": {
          "type": "code",
          "value": "props.typeOptions"
        },
        "search": {
          "type": "code",
          "value": "true"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        },
        "value": {
          "type": "code",
          "value": "props.filter?.training_type?? \"\""
        }
      },
      "seq": 28,
      "void": false
    },
    {
      "from": null,
      "id": 28,
      "name": "label",
      "parent": 20,
      "props": {
        "children": {
          "type": "value",
          "value": "พิมพ์ :",
          "valueEN": "Type :"
        },
        "id": {
          "type": "value",
          "value": "CardEmployeeTimeAttendanceUX-label-28"
        },
        "style": {
          "type": "code",
          "value": "{minWidth: \"max-content\"}"
        }
      },
      "seq": 27,
      "void": false
    },
    {
      "from": null,
      "id": 29,
      "name": "div",
      "parent": 21,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardEmployeeTimeAttendanceUX-div-29"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        }
      },
      "seq": 33,
      "void": false
    },
    {
      "from": null,
      "id": 30,
      "name": "div",
      "parent": 22,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardEmployeeTimeAttendanceUX-div-30"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        }
      },
      "seq": 34,
      "void": false
    },
    {
      "from": "react-lib/apps/common",
      "id": 31,
      "name": "DateTextBox",
      "parent": 29,
      "props": {
        "id": {
          "type": "value",
          "value": "CardEmployeeTimeAttendanceUX-DateTextBox-31"
        },
        "onChange": {
          "type": "code",
          "value": "(value: any)=>props.onChangeFilter?.(null,{name: \"start_date\", value})"
        },
        "value": {
          "type": "code",
          "value": "props.filter?.start_date"
        }
      },
      "seq": 31,
      "void": false
    },
    {
      "from": "react-lib/apps/common",
      "id": 32,
      "name": "DateTextBox",
      "parent": 30,
      "props": {
        "id": {
          "type": "value",
          "value": "CardEmployeeTimeAttendanceUX-DateTextBox-32"
        },
        "onChange": {
          "type": "code",
          "value": "(value: any)=>props.onChangeFilter?.(null,{name: \"expiry_date\", value})"
        },
        "value": {
          "type": "code",
          "value": "props.filter?.expiry_date"
        }
      },
      "seq": 32,
      "void": false
    },
    {
      "from": null,
      "id": 33,
      "name": "label",
      "parent": 21,
      "props": {
        "children": {
          "type": "value",
          "value": "วันที่เริ่มต้น :",
          "valueEN": "Start date :"
        },
        "id": {
          "type": "value",
          "value": "CardEmployeeTimeAttendanceUX-label-33"
        },
        "style": {
          "type": "code",
          "value": "{minWidth: \"max-content\"}"
        }
      },
      "seq": 29,
      "void": false
    },
    {
      "from": null,
      "id": 34,
      "name": "label",
      "parent": 22,
      "props": {
        "children": {
          "type": "value",
          "value": "วันหมดอายุ :",
          "valueEN": "Expiry date :"
        },
        "id": {
          "type": "value",
          "value": "CardEmployeeTimeAttendanceUX-label-34"
        },
        "style": {
          "type": "code",
          "value": "{minWidth: \"max-content\"}"
        }
      },
      "seq": 30,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 35,
      "name": "Button",
      "parent": 25,
      "props": {
        "color": {
          "type": "value",
          "value": "green"
        },
        "icon": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardEmployeeTimeAttendanceUX-Button-35"
        },
        "onClick": {
          "type": "code",
          "value": "props.onClickNewCourse"
        },
        "size": {
          "type": "value",
          "value": "small"
        },
        "style": {
          "type": "code",
          "value": "{minWidth: \"max-content\", display: props.hideNewCourse?\"none\":\"\"}"
        }
      },
      "seq": 38,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 36,
      "name": "Icon",
      "parent": 35,
      "props": {
        "id": {
          "type": "value",
          "value": "CardEmployeeTimeAttendanceUX-Icon-36"
        },
        "name": {
          "type": "value",
          "value": "plus"
        }
      },
      "seq": 36,
      "void": false
    },
    {
      "from": null,
      "id": 37,
      "name": "label",
      "parent": 35,
      "props": {
        "children": {
          "type": "value",
          "value": "หลักสูตรใหม่",
          "valueEN": "New Course"
        },
        "id": {
          "type": "value",
          "value": "CardEmployeeTimeAttendanceUX-label-37"
        },
        "style": {
          "type": "code",
          "value": "{marginLeft: \"6px\"}"
        }
      },
      "seq": 37,
      "void": false
    },
    {
      "from": "react-lib/frameworks/Table",
      "id": 39,
      "name": "Table",
      "parent": 15,
      "props": {
        "data": {
          "type": "code",
          "value": "props.tableData"
        },
        "getTrProps": {
          "type": "code",
          "value": "props.getTrProps"
        },
        "headers": {
          "type": "value",
          "value": "ID,Course Subject,Type,Pricing (Baht),Course period (hr),No. of participant,Start date,Expiry date,Status,Created"
        },
        "id": {
          "type": "value",
          "value": "CardEmployeeTimeAttendanceUX-Table-39"
        },
        "keys": {
          "type": "value",
          "value": "id,title,typeName,pricing,course_period,participants_count,startDate,expiryDate,statusName,created"
        },
        "minRows": {
          "type": "code",
          "value": "props.detail?3:14"
        },
        "showPagination": {
          "type": "code",
          "value": "false"
        },
        "sortable": {
          "type": "code",
          "value": "false"
        },
        "style": {
          "type": "code",
          "value": "{height: props.detail?\"calc(100vh - 34rem)\":\"calc(100vh - 12.5rem)\"}"
        },
        "widths": {
          "type": "value",
          "value": "^50,^200,^70,^80,^100,^110,^75,^75,^75,^120"
        }
      },
      "seq": 39,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 41,
      "name": "FormField",
      "parent": 2,
      "props": {
        "id": {
          "type": "value",
          "value": "CardCourseListUX-FormField-41"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "4"
        }
      },
      "seq": 22,
      "void": false
    },
    {
      "from": null,
      "id": 42,
      "name": "label",
      "parent": 41,
      "props": {
        "children": {
          "type": "value",
          "value": "สถานะ :",
          "valueEN": "Status :"
        },
        "id": {
          "type": "value",
          "value": "CardCourseListUX-label-42"
        },
        "style": {
          "type": "code",
          "value": "{minWidth: \"max-content\"}"
        }
      },
      "seq": 42,
      "void": false
    },
    {
      "from": null,
      "id": 43,
      "name": "div",
      "parent": 41,
      "props": {
        "children": {
          "type": "code",
          "value": "props.statusFilter"
        },
        "id": {
          "type": "value",
          "value": "CardCourseListUX-div-43"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        }
      },
      "seq": 43,
      "void": false
    },
    {
      "from": null,
      "id": 44,
      "name": "div",
      "parent": 23,
      "props": {
        "children": {
          "type": "code",
          "value": "props.buttonPrint"
        },
        "id": {
          "type": "value",
          "value": "CardCourseListUX-div-44"
        }
      },
      "seq": 44,
      "void": false
    },
    {
      "from": null,
      "id": 46,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardCourseListUX-div-46"
        },
        "style": {
          "type": "code",
          "value": "{display: props.detail? \"\" : \"none\"}"
        }
      },
      "seq": 46,
      "void": false
    },
    {
      "from": null,
      "id": 47,
      "name": "div",
      "parent": 46,
      "props": {
        "children": {
          "type": "code",
          "value": "props.detail?.id?props.detail?.subject:\"New Course\""
        },
        "id": {
          "type": "value",
          "value": "CardCourseListUX-div-47"
        },
        "style": {
          "type": "code",
          "value": "{color: \"rgba(33, 133, 208, 1)\", fontWeight: \"bold\", margin: \"1.5rem 0 1rem\"}"
        }
      },
      "seq": 47,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 48,
      "name": "Form",
      "parent": 46,
      "props": {
        "className": {
          "type": "value",
          "value": "--override-disabled --grey"
        },
        "id": {
          "type": "value",
          "value": "CardCourseListUX-Form-48"
        }
      },
      "seq": 48,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 49,
      "name": "FormGroup",
      "parent": 48,
      "props": {
        "id": {
          "type": "value",
          "value": "CardCourseListUX-FormGroup-49"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 49,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 50,
      "name": "FormGroup",
      "parent": 48,
      "props": {
        "id": {
          "type": "value",
          "value": "CardCourseListUX-FormGroup-50"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 50,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 51,
      "name": "FormGroup",
      "parent": 48,
      "props": {
        "id": {
          "type": "value",
          "value": "CardCourseListUX-FormGroup-51"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 51,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 52,
      "name": "FormField",
      "parent": 49,
      "props": {
        "className": {
          "type": "code",
          "value": "`required ${props.showRequiredField?.subject? \"error\" : \"\"}`"
        },
        "id": {
          "type": "value",
          "value": "CardCourseListUX-FormField-52"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{position: \"relative\"}"
        },
        "width": {
          "type": "code",
          "value": "8"
        }
      },
      "seq": 52,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 53,
      "name": "FormField",
      "parent": 50,
      "props": {
        "className": {
          "type": "code",
          "value": "`required ${props.showRequiredField?.training_type? \"error\" : \"\"}`"
        },
        "id": {
          "type": "value",
          "value": "CardCourseListUX-FormField-53"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{position: \"relative\"}"
        },
        "width": {
          "type": "code",
          "value": "4"
        }
      },
      "seq": 53,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 54,
      "name": "FormField",
      "parent": 50,
      "props": {
        "className": {
          "type": "code",
          "value": "`required ${props.showRequiredField?.pricing? \"error\" : \"\"}`"
        },
        "id": {
          "type": "value",
          "value": "CardCourseListUX-FormField-54"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{position: \"relative\"}"
        },
        "width": {
          "type": "code",
          "value": "3"
        }
      },
      "seq": 54,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 55,
      "name": "FormField",
      "parent": 50,
      "props": {
        "id": {
          "type": "value",
          "value": "CardCourseListUX-FormField-55"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 55,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 56,
      "name": "FormField",
      "parent": 51,
      "props": {
        "id": {
          "type": "value",
          "value": "CardCourseListUX-FormField-56"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "8"
        }
      },
      "seq": 56,
      "void": false
    },
    {
      "from": null,
      "id": 57,
      "name": "label",
      "parent": 56,
      "props": {
        "children": {
          "type": "value",
          "value": "สถานที่ :",
          "valueEN": "Venue :"
        },
        "id": {
          "type": "value",
          "value": "CardCourseListUX-label-57"
        },
        "style": {
          "type": "code",
          "value": "{minWidth: \"50px\"}"
        }
      },
      "seq": 57,
      "void": false
    },
    {
      "from": null,
      "id": 58,
      "name": "label",
      "parent": 55,
      "props": {
        "children": {
          "type": "value",
          "value": "บาท",
          "valueEN": "Baht"
        },
        "id": {
          "type": "value",
          "value": "CardCourseListUX-label-58"
        }
      },
      "seq": 58,
      "void": false
    },
    {
      "from": null,
      "id": 59,
      "name": "label",
      "parent": 54,
      "props": {
        "children": {
          "type": "value",
          "value": "ราคา :",
          "valueEN": "Pricing :"
        },
        "id": {
          "type": "value",
          "value": "CardCourseListUX-label-59"
        },
        "style": {
          "type": "code",
          "value": "{minWidth: \"max-content\"}"
        }
      },
      "seq": 59,
      "void": false
    },
    {
      "from": null,
      "id": 60,
      "name": "label",
      "parent": 53,
      "props": {
        "children": {
          "type": "value",
          "value": "พิมพ์ :",
          "valueEN": "Type :"
        },
        "id": {
          "type": "value",
          "value": "CardCourseListUX-label-60"
        },
        "style": {
          "type": "code",
          "value": "{minWidth: \"50px\"}"
        }
      },
      "seq": 60,
      "void": false
    },
    {
      "from": null,
      "id": 61,
      "name": "label",
      "parent": 52,
      "props": {
        "children": {
          "type": "value",
          "value": "ชื่อ :",
          "valueEN": "Title :"
        },
        "id": {
          "type": "value",
          "value": "CardCourseListUX-label-61"
        },
        "style": {
          "type": "code",
          "value": "{minWidth: \"50px\"}"
        }
      },
      "seq": 61,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 62,
      "name": "Input",
      "parent": 52,
      "props": {
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardCourseListUX-Input-62"
        },
        "name": {
          "type": "value",
          "value": "subject"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeValue"
        },
        "readOnly": {
          "type": "code",
          "value": "props.readOnly"
        },
        "value": {
          "type": "code",
          "value": "props.detail?.subject?? \"\""
        }
      },
      "seq": 62,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 63,
      "name": "Input",
      "parent": 56,
      "props": {
        "disabled": {
          "type": "code",
          "value": "props.readOnly"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardCourseListUX-Input-63"
        },
        "name": {
          "type": "value",
          "value": "venue"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeValue"
        },
        "value": {
          "type": "code",
          "value": "props.detail?.venue?? \"\""
        }
      },
      "seq": 63,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 64,
      "name": "Input",
      "parent": 54,
      "props": {
        "disabled": {
          "type": "code",
          "value": ""
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardCourseListUX-Input-64"
        },
        "name": {
          "type": "value",
          "value": "pricing"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeValue"
        },
        "onKeyDown": {
          "type": "code",
          "value": ""
        },
        "readOnly": {
          "type": "code",
          "value": "props.readOnly"
        },
        "type": {
          "type": "value",
          "value": ""
        },
        "value": {
          "type": "code",
          "value": "props.detail?.pricing?? \"\""
        }
      },
      "seq": 64,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 65,
      "name": "Dropdown",
      "parent": 53,
      "props": {
        "disabled": {
          "type": "code",
          "value": "props.readOnly"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardCourseListUX-Dropdown-65"
        },
        "name": {
          "type": "value",
          "value": "training_type"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeValue"
        },
        "options": {
          "type": "code",
          "value": "props.typeOptions"
        },
        "search": {
          "type": "code",
          "value": "true"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        },
        "value": {
          "type": "code",
          "value": "props.detail?.training_type?? \"\""
        }
      },
      "seq": 65,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 66,
      "name": "FormGroup",
      "parent": 48,
      "props": {
        "id": {
          "type": "value",
          "value": "CardCourseListUX-FormGroup-66"
        }
      },
      "seq": 66,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 67,
      "name": "FormField",
      "parent": 66,
      "props": {
        "id": {
          "type": "value",
          "value": "CardCourseListUX-FormField-67"
        },
        "width": {
          "type": "code",
          "value": "8"
        }
      },
      "seq": 67,
      "void": false
    },
    {
      "from": null,
      "id": 68,
      "name": "label",
      "parent": 67,
      "props": {
        "children": {
          "type": "value",
          "value": "คำอธิบาย",
          "valueEN": "Description"
        },
        "id": {
          "type": "value",
          "value": "CardCourseListUX-label-68"
        }
      },
      "seq": 68,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 69,
      "name": "TextArea",
      "parent": 67,
      "props": {
        "id": {
          "type": "value",
          "value": "CardCourseListUX-TextArea-69"
        },
        "name": {
          "type": "value",
          "value": "description"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeValue"
        },
        "readOnly": {
          "type": "code",
          "value": "props.readOnly"
        },
        "rows": {
          "type": "code",
          "value": "5"
        },
        "value": {
          "type": "code",
          "value": "props.detail?.description?? \"\""
        }
      },
      "seq": 69,
      "void": true
    },
    {
      "from": "semantic-ui-react",
      "id": 70,
      "name": "FormGroup",
      "parent": 48,
      "props": {
        "id": {
          "type": "value",
          "value": "CardCourseListUX-FormGroup-70"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 70,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 71,
      "name": "FormField",
      "parent": 70,
      "props": {
        "id": {
          "type": "value",
          "value": "CardCourseListUX-FormField-71"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "6"
        }
      },
      "seq": 71,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 72,
      "name": "FormField",
      "parent": 70,
      "props": {
        "id": {
          "type": "value",
          "value": "CardCourseListUX-FormField-72"
        }
      },
      "seq": 72,
      "void": false
    },
    {
      "from": null,
      "id": 73,
      "name": "label",
      "parent": 71,
      "props": {
        "children": {
          "type": "value",
          "value": "Attachments: "
        },
        "id": {
          "type": "value",
          "value": "CardCourseListUX-label-73"
        }
      },
      "seq": 73,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 74,
      "name": "Input",
      "parent": 71,
      "props": {
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardCourseListUX-Input-74"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeLink"
        },
        "placeholder": {
          "type": "value",
          "value": "Enter URL (Photo, YouTube, PDF, or webpage)"
        },
        "readOnly": {
          "type": "code",
          "value": "props.readOnly"
        },
        "value": {
          "type": "code",
          "value": "props.link ?? \"\""
        }
      },
      "seq": 74,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 75,
      "name": "Button",
      "parent": 72,
      "props": {
        "children": {
          "type": "value",
          "value": "เพิ่มลิงค์",
          "valueEN": "ADD LINK"
        },
        "color": {
          "type": "value",
          "value": "green"
        },
        "disabled": {
          "type": "code",
          "value": "!props.link"
        },
        "id": {
          "type": "value",
          "value": "CardCourseListUX-Button-75"
        },
        "onClick": {
          "type": "code",
          "value": "props.onAddLink"
        }
      },
      "seq": 75,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 76,
      "name": "FormGroup",
      "parent": 48,
      "props": {
        "id": {
          "type": "value",
          "value": "CardCourseListUX-FormGroup-76"
        },
        "style": {
          "type": "code",
          "value": "{marginBottom: 0}"
        }
      },
      "seq": 76,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 77,
      "name": "FormGroup",
      "parent": 48,
      "props": {
        "id": {
          "type": "value",
          "value": "CardCourseListUX-FormGroup-77"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 77,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 78,
      "name": "FormField",
      "parent": 77,
      "props": {
        "className": {
          "type": "code",
          "value": "`required ${props.showRequiredField?.start_date? \"error\" : \"\"}`"
        },
        "id": {
          "type": "value",
          "value": "CardCourseListUX-FormField-78"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{position: \"relative\"}"
        },
        "width": {
          "type": "code",
          "value": "3"
        }
      },
      "seq": 78,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 79,
      "name": "FormField",
      "parent": 77,
      "props": {
        "className": {
          "type": "code",
          "value": "`${props.showRequiredField?.start_time? \"error\" : \"\"}`"
        },
        "id": {
          "type": "value",
          "value": "CardCourseListUX-FormField-79"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{position: \"relative\"}"
        },
        "width": {
          "type": "code",
          "value": "3"
        }
      },
      "seq": 79,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 80,
      "name": "FormField",
      "parent": 77,
      "props": {
        "className": {
          "type": "code",
          "value": "`required ${props.showRequiredField?.end_date? \"error\" : \"\"}`"
        },
        "id": {
          "type": "value",
          "value": "CardCourseListUX-FormField-80"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{position: \"relative\"}"
        },
        "width": {
          "type": "code",
          "value": "3"
        }
      },
      "seq": 80,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 81,
      "name": "FormField",
      "parent": 77,
      "props": {
        "className": {
          "type": "code",
          "value": "`${props.showRequiredField?.end_time? \"error\" : \"\"}`"
        },
        "id": {
          "type": "value",
          "value": "CardCourseListUX-FormField-81"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{position: \"relative\"}"
        },
        "width": {
          "type": "code",
          "value": "3"
        }
      },
      "seq": 81,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 82,
      "name": "FormField",
      "parent": 77,
      "props": {
        "className": {
          "type": "code",
          "value": "`required ${props.showRequiredField?.course_period? \"error\" : \"\"}`"
        },
        "id": {
          "type": "value",
          "value": "CardCourseListUX-FormField-82"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{position: \"relative\"}"
        },
        "width": {
          "type": "code",
          "value": "2"
        }
      },
      "seq": 82,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 83,
      "name": "FormField",
      "parent": 77,
      "props": {
        "id": {
          "type": "value",
          "value": "CardCourseListUX-FormField-83"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 83,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 84,
      "name": "FormGroup",
      "parent": 48,
      "props": {
        "id": {
          "type": "value",
          "value": "CardCourseListUX-FormGroup-84"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 84,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 85,
      "name": "FormField",
      "parent": 84,
      "props": {
        "className": {
          "type": "code",
          "value": "`required ${props.showRequiredField?.expiry_date? \"error\" : \"\"}`"
        },
        "id": {
          "type": "value",
          "value": "CardCourseListUX-FormField-85"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{position: \"relative\"}"
        },
        "width": {
          "type": "code",
          "value": "3"
        }
      },
      "seq": 85,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 86,
      "name": "FormGroup",
      "parent": 48,
      "props": {
        "id": {
          "type": "value",
          "value": "CardCourseListUX-FormGroup-86"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 86,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 87,
      "name": "FormGroup",
      "parent": 48,
      "props": {
        "id": {
          "type": "value",
          "value": "CardCourseListUX-FormGroup-87"
        },
        "style": {
          "type": "code",
          "value": "{marginBottom: \"0\"}"
        }
      },
      "seq": 87,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 88,
      "name": "FormGroup",
      "parent": 48,
      "props": {
        "id": {
          "type": "value",
          "value": "CardCourseListUX-FormGroup-88"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 89,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 89,
      "name": "FormGroup",
      "parent": 48,
      "props": {
        "id": {
          "type": "value",
          "value": "CardCourseListUX-FormGroup-89"
        },
        "style": {
          "type": "code",
          "value": "{marginBottom: \"0\"}"
        }
      },
      "seq": 115,
      "void": false
    },
    {
      "from": null,
      "id": 90,
      "name": "label",
      "parent": 78,
      "props": {
        "children": {
          "type": "value",
          "value": "วันที่เริ่มต้น :",
          "valueEN": "Start date :"
        },
        "id": {
          "type": "value",
          "value": "CardCourseListUX-label-90"
        },
        "style": {
          "type": "code",
          "value": "{minWidth: \"max-content\"}"
        }
      },
      "seq": 90,
      "void": false
    },
    {
      "from": null,
      "id": 91,
      "name": "label",
      "parent": 79,
      "props": {
        "children": {
          "type": "value",
          "value": "เวลาเริ่มต้น :",
          "valueEN": "Start time :"
        },
        "id": {
          "type": "value",
          "value": "CardCourseListUX-label-91"
        },
        "style": {
          "type": "code",
          "value": "{minWidth: \"max-content\"}"
        }
      },
      "seq": 91,
      "void": false
    },
    {
      "from": null,
      "id": 92,
      "name": "label",
      "parent": 80,
      "props": {
        "children": {
          "type": "value",
          "value": "วันที่สิ้นสุด :",
          "valueEN": "End date :"
        },
        "id": {
          "type": "value",
          "value": "CardCourseListUX-label-92"
        },
        "style": {
          "type": "code",
          "value": "{minWidth: \"max-content\"}"
        }
      },
      "seq": 92,
      "void": false
    },
    {
      "from": null,
      "id": 93,
      "name": "label",
      "parent": 81,
      "props": {
        "children": {
          "type": "value",
          "value": "เวลาสิ้นสุด :",
          "valueEN": "End time :"
        },
        "id": {
          "type": "value",
          "value": "CardCourseListUX-label-93"
        },
        "style": {
          "type": "code",
          "value": "{minWidth: \"max-content\"}"
        }
      },
      "seq": 93,
      "void": false
    },
    {
      "from": null,
      "id": 94,
      "name": "label",
      "parent": 82,
      "props": {
        "children": {
          "type": "value",
          "value": "ระยะเวลาหลักสูตร",
          "valueEN": "Course period"
        },
        "id": {
          "type": "value",
          "value": "CardCourseListUX-label-94"
        },
        "style": {
          "type": "code",
          "value": "{minWidth: \"max-content\"}"
        }
      },
      "seq": 94,
      "void": false
    },
    {
      "from": null,
      "id": 95,
      "name": "label",
      "parent": 83,
      "props": {
        "children": {
          "type": "value",
          "value": "ชั่วโมง",
          "valueEN": "hr"
        },
        "id": {
          "type": "value",
          "value": "CardCourseListUX-label-95"
        },
        "style": {
          "type": "code",
          "value": "{paddingLeft: \"1rem\"}"
        }
      },
      "seq": 95,
      "void": false
    },
    {
      "from": null,
      "id": 96,
      "name": "div",
      "parent": 78,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardCourseListUX-div-96"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        }
      },
      "seq": 96,
      "void": false
    },
    {
      "from": null,
      "id": 97,
      "name": "div",
      "parent": 80,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardCourseListUX-div-97"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        }
      },
      "seq": 97,
      "void": false
    },
    {
      "from": "react-lib/apps/common",
      "id": 98,
      "name": "DateTextBox",
      "parent": 96,
      "props": {
        "disabled": {
          "type": "code",
          "value": "props.readOnly"
        },
        "id": {
          "type": "value",
          "value": "CardCourseListUX-DateTextBox-98"
        },
        "onChange": {
          "type": "code",
          "value": "(value: any)=>props.onChangeValue?.(null, {name:\"start_date\", value})"
        },
        "style": {
          "type": "code",
          "value": "{color: \"rgba(0,0,0,.87)\"}"
        },
        "value": {
          "type": "code",
          "value": "props.detail?.start_date?? \"\""
        }
      },
      "seq": 98,
      "void": false
    },
    {
      "from": "react-lib/apps/common",
      "id": 99,
      "name": "DateTextBox",
      "parent": 97,
      "props": {
        "disabled": {
          "type": "code",
          "value": "props.readOnly"
        },
        "id": {
          "type": "value",
          "value": "CardCourseListUX-DateTextBox-99"
        },
        "onChange": {
          "type": "code",
          "value": "(value: any)=>props.onChangeValue?.(null, {name:\"end_date\", value})"
        },
        "style": {
          "type": "code",
          "value": "{color: \"rgba(0,0,0,.87)\"}"
        },
        "value": {
          "type": "code",
          "value": "props.detail?.end_date?? \"\""
        }
      },
      "seq": 99,
      "void": false
    },
    {
      "from": null,
      "id": 100,
      "name": "div",
      "parent": 79,
      "props": {
        "children": {
          "type": "code",
          "value": "props.startTime"
        },
        "id": {
          "type": "value",
          "value": "CardCourseListUX-div-100"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        }
      },
      "seq": 100,
      "void": false
    },
    {
      "from": null,
      "id": 101,
      "name": "div",
      "parent": 81,
      "props": {
        "children": {
          "type": "code",
          "value": "props.endTime"
        },
        "id": {
          "type": "value",
          "value": "CardCourseListUX-div-101"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        }
      },
      "seq": 101,
      "void": false
    },
    {
      "from": null,
      "id": 102,
      "name": "label",
      "parent": 85,
      "props": {
        "children": {
          "type": "value",
          "value": "วันหมดอายุ :",
          "valueEN": "Expiry date :"
        },
        "id": {
          "type": "value",
          "value": "CardCourseListUX-label-102"
        },
        "style": {
          "type": "code",
          "value": "{minWidth: \"max-content\"}"
        }
      },
      "seq": 102,
      "void": false
    },
    {
      "from": null,
      "id": 103,
      "name": "div",
      "parent": 85,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardCourseListUX-div-103"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        }
      },
      "seq": 103,
      "void": false
    },
    {
      "from": "react-lib/apps/common",
      "id": 104,
      "name": "DateTextBox",
      "parent": 103,
      "props": {
        "disabled": {
          "type": "code",
          "value": "!props.enabledExpiryDate || props.readOnly"
        },
        "id": {
          "type": "value",
          "value": "CardCourseListUX-DateTextBox-104"
        },
        "onChange": {
          "type": "code",
          "value": "(value: any)=>props.onChangeValue?.(null, {name:\"expiry_date\", value})"
        },
        "style": {
          "type": "code",
          "value": "{color: \"rgba(0,0,0,.87)\"}"
        },
        "value": {
          "type": "code",
          "value": "props.detail?.expiry_date??\"\""
        }
      },
      "seq": 104,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 105,
      "name": "Input",
      "parent": 82,
      "props": {
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardCourseListUX-Input-105"
        },
        "name": {
          "type": "value",
          "value": "course_period"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeValue"
        },
        "onKeyDown": {
          "type": "code",
          "value": ""
        },
        "readOnly": {
          "type": "code",
          "value": "props.readOnly"
        },
        "style": {
          "type": "code",
          "value": "{minWidth: \"5rem\"}"
        },
        "type": {
          "type": "value",
          "value": ""
        },
        "value": {
          "type": "code",
          "value": "props.detail?.course_period?? \"\""
        }
      },
      "seq": 105,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 106,
      "name": "FormField",
      "parent": 86,
      "props": {
        "id": {
          "type": "value",
          "value": "CardCourseListUX-FormField-106"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 106,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 107,
      "name": "FormField",
      "parent": 86,
      "props": {
        "id": {
          "type": "value",
          "value": "CardCourseListUX-FormField-107"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 107,
      "void": false
    },
    {
      "from": null,
      "id": 108,
      "name": "label",
      "parent": 106,
      "props": {
        "children": {
          "type": "value",
          "value": "การประเมิน",
          "valueEN": "Evaluation"
        },
        "id": {
          "type": "value",
          "value": "CardCourseListUX-label-108"
        }
      },
      "seq": 108,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 109,
      "name": "Button",
      "parent": 107,
      "props": {
        "color": {
          "type": "value",
          "value": "green"
        },
        "disabled": {
          "type": "code",
          "value": "props.readOnly"
        },
        "icon": {
          "type": "value",
          "value": "plus"
        },
        "id": {
          "type": "value",
          "value": "CardCourseListUX-Button-109"
        },
        "onClick": {
          "type": "code",
          "value": "props.onAddEvaluation"
        },
        "size": {
          "type": "value",
          "value": "mini"
        },
        "style": {
          "type": "code",
          "value": "{fontSize: \"0.55rem\"}"
        }
      },
      "seq": 109,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 110,
      "name": "FormField",
      "parent": 88,
      "props": {
        "id": {
          "type": "value",
          "value": "CardCourseListUX-FormField-110"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "6"
        }
      },
      "seq": 160,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 111,
      "name": "FormField",
      "parent": 88,
      "props": {
        "id": {
          "type": "value",
          "value": "CardCourseListUX-FormField-111"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 165,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 115,
      "name": "FormGroup",
      "parent": 48,
      "props": {
        "id": {
          "type": "value",
          "value": "CardCourseListUX-FormGroup-115"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 118,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 116,
      "name": "FormField",
      "parent": 115,
      "props": {
        "id": {
          "type": "value",
          "value": "CardCourseListUX-FormField-116"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 116,
      "void": false
    },
    {
      "from": null,
      "id": 117,
      "name": "label",
      "parent": 116,
      "props": {
        "children": {
          "type": "code",
          "value": "`Total participant :  ${props.totalParticipant ?? \"0\"}`"
        },
        "id": {
          "type": "value",
          "value": "CardCourseListUX-label-117"
        },
        "style": {
          "type": "code",
          "value": "{fontWeight: \"normal\"}"
        }
      },
      "seq": 117,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 118,
      "name": "FormGroup",
      "parent": 48,
      "props": {
        "id": {
          "type": "value",
          "value": "CardCourseListUX-FormGroup-118"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 157,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 119,
      "name": "FormField",
      "parent": 118,
      "props": {
        "id": {
          "type": "value",
          "value": "CardCourseListUX-FormField-119"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{flex:1}"
        }
      },
      "seq": 119,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 120,
      "name": "FormField",
      "parent": 118,
      "props": {
        "id": {
          "type": "value",
          "value": "CardCourseListUX-FormField-120"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 120,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 121,
      "name": "FormField",
      "parent": 118,
      "props": {
        "id": {
          "type": "value",
          "value": "CardCourseListUX-FormField-121"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 154,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 123,
      "name": "Button",
      "parent": 121,
      "props": {
        "children": {
          "type": "value",
          "value": "ยกเลิก",
          "valueEN": "CANCEL"
        },
        "color": {
          "type": "value",
          "value": "red"
        },
        "id": {
          "type": "value",
          "value": "CardCourseListUX-Button-123"
        },
        "onClick": {
          "type": "code",
          "value": "props.onClickCancel"
        },
        "size": {
          "type": "value",
          "value": "small"
        }
      },
      "seq": 123,
      "void": false
    },
    {
      "from": null,
      "id": 125,
      "name": "div",
      "parent": 87,
      "props": {
        "children": {
          "type": "code",
          "value": "props.evaluationList"
        },
        "className": {
          "type": "value",
          "value": "field"
        },
        "id": {
          "type": "value",
          "value": "CardCourseListUX-div-125"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        }
      },
      "seq": 125,
      "void": false
    },
    {
      "from": null,
      "id": 126,
      "name": "div",
      "parent": 89,
      "props": {
        "children": {
          "type": "code",
          "value": "props.participantList"
        },
        "className": {
          "type": "value",
          "value": "field"
        },
        "id": {
          "type": "value",
          "value": "CardCourseListUX-div-126"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        }
      },
      "seq": 126,
      "void": false
    },
    {
      "from": null,
      "id": 127,
      "name": "div",
      "parent": 76,
      "props": {
        "children": {
          "type": "code",
          "value": "props.attachmentList"
        },
        "className": {
          "type": "value",
          "value": "field"
        },
        "id": {
          "type": "value",
          "value": "CardCourseListUX-div-127"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        }
      },
      "seq": 127,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 128,
      "name": "FormField",
      "parent": 118,
      "props": {
        "id": {
          "type": "value",
          "value": "CardCourseListUX-FormField-128"
        },
        "style": {
          "type": "code",
          "value": "{display: props.detail?.id && !props.hideDeleteCourse?\"\":\"none\"}"
        }
      },
      "seq": 121,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 129,
      "name": "Button",
      "parent": 128,
      "props": {
        "children": {
          "type": "value",
          "value": "ลบหลักสูตร",
          "valueEN": "Delete Course"
        },
        "color": {
          "type": "value",
          "value": "red"
        },
        "disabled": {
          "type": "code",
          "value": "props.detail?.is_approved??false"
        },
        "id": {
          "type": "value",
          "value": "CardCourseListUX-Button-129"
        },
        "onClick": {
          "type": "code",
          "value": "props.onDelete"
        },
        "size": {
          "type": "value",
          "value": "small"
        }
      },
      "seq": 129,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 130,
      "name": "Button",
      "parent": 120,
      "props": {
        "children": {
          "type": "value",
          "value": "บันทึก",
          "valueEN": "SAVE"
        },
        "color": {
          "type": "value",
          "value": "green"
        },
        "id": {
          "type": "value",
          "value": "CardCourseListUX-Button-130"
        },
        "onClick": {
          "type": "code",
          "value": "props.onSave"
        },
        "size": {
          "type": "value",
          "value": "small"
        }
      },
      "seq": 130,
      "void": false
    },
    {
      "from": null,
      "id": 131,
      "name": "div",
      "parent": 52,
      "props": {
        "children": {
          "type": "code",
          "value": "props.showRequiredField?.subject|| \"\""
        },
        "id": {
          "type": "value",
          "value": "CardCourseListUX-div-131"
        },
        "style": {
          "type": "code",
          "value": "{position: \"absolute\", bottom: \"-16px\", color: \"red\", fontSize: \"0.75rem\", right: \"15px\"}"
        }
      },
      "seq": 131,
      "void": false
    },
    {
      "from": null,
      "id": 132,
      "name": "div",
      "parent": 53,
      "props": {
        "children": {
          "type": "code",
          "value": "props.showRequiredField?.training_type|| \"\""
        },
        "id": {
          "type": "value",
          "value": "CardCourseListUX-div-132"
        },
        "style": {
          "type": "code",
          "value": "{position: \"absolute\", bottom: \"-16px\", color: \"red\", fontSize: \"0.75rem\", right: \"15px\"}"
        }
      },
      "seq": 132,
      "void": false
    },
    {
      "from": null,
      "id": 133,
      "name": "div",
      "parent": 54,
      "props": {
        "children": {
          "type": "code",
          "value": "props.showRequiredField?.pricing|| \"\""
        },
        "id": {
          "type": "value",
          "value": "CardCourseListUX-div-133"
        },
        "style": {
          "type": "code",
          "value": "{position: \"absolute\", bottom: \"-16px\", color: \"red\", fontSize: \"0.75rem\", right: \"15px\"}"
        }
      },
      "seq": 133,
      "void": false
    },
    {
      "from": null,
      "id": 134,
      "name": "div",
      "parent": 78,
      "props": {
        "children": {
          "type": "code",
          "value": "props.showRequiredField?.start_date|| \"\""
        },
        "id": {
          "type": "value",
          "value": "CardCourseListUX-div-134"
        },
        "style": {
          "type": "code",
          "value": "{position: \"absolute\", bottom: \"-16px\", color: \"red\", fontSize: \"0.75rem\", right: \"15px\"}"
        }
      },
      "seq": 134,
      "void": false
    },
    {
      "from": null,
      "id": 135,
      "name": "div",
      "parent": 80,
      "props": {
        "children": {
          "type": "code",
          "value": "props.showRequiredField?.end_date|| \"\""
        },
        "id": {
          "type": "value",
          "value": "CardCourseListUX-div-135"
        },
        "style": {
          "type": "code",
          "value": "{position: \"absolute\", bottom: \"-16px\", color: \"red\", fontSize: \"0.75rem\", right: \"15px\"}"
        }
      },
      "seq": 135,
      "void": false
    },
    {
      "from": null,
      "id": 136,
      "name": "div",
      "parent": 82,
      "props": {
        "children": {
          "type": "code",
          "value": "props.showRequiredField?.course_period|| \"\""
        },
        "id": {
          "type": "value",
          "value": "CardCourseListUX-div-136"
        },
        "style": {
          "type": "code",
          "value": "{position: \"absolute\", bottom: \"-16px\", color: \"red\", fontSize: \"0.75rem\", right: \"0\"}"
        }
      },
      "seq": 136,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 137,
      "name": "Input",
      "parent": 6,
      "props": {
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "icon": {
          "type": "value",
          "value": "search"
        },
        "id": {
          "type": "value",
          "value": "CardCourseListUX-Input-137"
        },
        "name": {
          "type": "value",
          "value": "course_name_id"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeFilter"
        },
        "value": {
          "type": "code",
          "value": "props.filter?.course_name_id ?? \"\""
        }
      },
      "seq": 137,
      "void": false
    },
    {
      "from": null,
      "id": 138,
      "name": "div",
      "parent": 81,
      "props": {
        "children": {
          "type": "code",
          "value": "props.showRequiredField?.end_time|| \"\""
        },
        "id": {
          "type": "value",
          "value": "CardCourseListUX-div-138"
        },
        "style": {
          "type": "code",
          "value": "{position: \"absolute\", bottom: \"-16px\", color: \"red\", fontSize: \"0.75rem\", right: \"15px\"}"
        }
      },
      "seq": 138,
      "void": false
    },
    {
      "from": null,
      "id": 139,
      "name": "div",
      "parent": 79,
      "props": {
        "children": {
          "type": "code",
          "value": "props.showRequiredField?.start_time|| \"\""
        },
        "id": {
          "type": "value",
          "value": "CardCourseListUX-div-139"
        },
        "style": {
          "type": "code",
          "value": "{position: \"absolute\", bottom: \"-16px\", color: \"red\", fontSize: \"0.75rem\", right: \"15px\"}"
        }
      },
      "seq": 139,
      "void": false
    },
    {
      "from": null,
      "id": 141,
      "name": "div",
      "parent": 85,
      "props": {
        "children": {
          "type": "code",
          "value": "props.showRequiredField?.expiry_date|| \"\""
        },
        "id": {
          "type": "value",
          "value": "CardCourseListUX-div-141"
        },
        "style": {
          "type": "code",
          "value": "{position: \"absolute\", bottom: \"-16px\", color: \"red\", fontSize: \"0.75rem\", right: \"15px\"}"
        }
      },
      "seq": 141,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 142,
      "name": "FormField",
      "parent": 49,
      "props": {
        "id": {
          "type": "value",
          "value": "CardCourseListUX-FormField-142"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "8"
        }
      },
      "seq": 145,
      "void": false
    },
    {
      "from": null,
      "id": 143,
      "name": "label",
      "parent": 142,
      "props": {
        "children": {
          "type": "value",
          "value": "หัวข้อ"
        },
        "id": {
          "type": "value",
          "value": "CardCourseListUX-label-143"
        },
        "style": {
          "type": "code",
          "value": "{minWidth: \"50px\"}"
        }
      },
      "seq": 143,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 144,
      "name": "Input",
      "parent": 142,
      "props": {
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardCourseListUX-Input-144"
        },
        "name": {
          "type": "value",
          "value": "subject_th"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeValue"
        },
        "readOnly": {
          "type": "code",
          "value": "props.readOnly"
        },
        "value": {
          "type": "code",
          "value": "props.detail?.subject_th?? \"\""
        }
      },
      "seq": 144,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 145,
      "name": "FormField",
      "parent": 49,
      "props": {
        "id": {
          "type": "value",
          "value": "CardCourseListUX-FormField-145"
        },
        "style": {
          "type": "code",
          "value": "{minWidth: \"3rem\"}"
        },
        "width": {
          "type": "value",
          "value": ""
        }
      },
      "seq": 142,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 146,
      "name": "FormField",
      "parent": 51,
      "props": {
        "id": {
          "type": "value",
          "value": "CardCourseListUX-FormField-146"
        },
        "style": {
          "type": "code",
          "value": "{minWidth: \"3rem\"}"
        },
        "width": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 146,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 147,
      "name": "FormField",
      "parent": 51,
      "props": {
        "id": {
          "type": "value",
          "value": "CardCourseListUX-FormField-147"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "8"
        }
      },
      "seq": 147,
      "void": false
    },
    {
      "from": null,
      "id": 148,
      "name": "label",
      "parent": 147,
      "props": {
        "children": {
          "type": "value",
          "value": "สถานที่ :"
        },
        "id": {
          "type": "value",
          "value": "CardCourseListUX-label-148"
        },
        "style": {
          "type": "code",
          "value": "{minWidth: \"50px\"}"
        }
      },
      "seq": 148,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 149,
      "name": "Input",
      "parent": 147,
      "props": {
        "disabled": {
          "type": "code",
          "value": "props.readOnly"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardCourseListUX-Input-149"
        },
        "name": {
          "type": "value",
          "value": "venue_th"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeValue"
        },
        "value": {
          "type": "code",
          "value": "props.detail?.venue_th?? \"\""
        }
      },
      "seq": 149,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 150,
      "name": "FormField",
      "parent": 66,
      "props": {
        "id": {
          "type": "value",
          "value": "CardCourseListUX-FormField-150"
        },
        "style": {
          "type": "code",
          "value": "{minWidth: \"3rem\"}"
        },
        "width": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 150,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 151,
      "name": "FormField",
      "parent": 66,
      "props": {
        "id": {
          "type": "value",
          "value": "CardCourseListUX-FormField-151"
        },
        "style": {
          "type": "code",
          "value": "{paddingLeft: \"0\", paddingRight: \"1.5rem\"}"
        },
        "width": {
          "type": "code",
          "value": "8"
        }
      },
      "seq": 151,
      "void": false
    },
    {
      "from": null,
      "id": 152,
      "name": "label",
      "parent": 151,
      "props": {
        "children": {
          "type": "value",
          "value": "คำอธิบาย"
        },
        "id": {
          "type": "value",
          "value": "CardCourseListUX-label-152"
        }
      },
      "seq": 152,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 153,
      "name": "TextArea",
      "parent": 151,
      "props": {
        "id": {
          "type": "value",
          "value": "CardCourseListUX-TextArea-153"
        },
        "name": {
          "type": "value",
          "value": "description_th"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeValue"
        },
        "readOnly": {
          "type": "code",
          "value": "props.readOnly"
        },
        "rows": {
          "type": "value",
          "value": "5"
        },
        "value": {
          "type": "code",
          "value": "props.detail?.description_th?? \"\""
        }
      },
      "seq": 153,
      "void": true
    },
    {
      "from": "semantic-ui-react",
      "id": 154,
      "name": "FormField",
      "parent": 118,
      "props": {
        "id": {
          "type": "value",
          "value": "CardCourseListUX-FormField-154"
        }
      },
      "seq": 128,
      "void": false
    },
    {
      "from": null,
      "id": 156,
      "name": "div",
      "parent": 154,
      "props": {
        "children": {
          "type": "code",
          "value": "props.buttonActive"
        },
        "id": {
          "type": "value",
          "value": "CardCourseListUX-div-156"
        }
      },
      "seq": 156,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 157,
      "name": "FormGroup",
      "parent": 48,
      "props": {
        "id": {
          "type": "value",
          "value": "CardCourseListUX-FormGroup-157"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 88,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 158,
      "name": "FormField",
      "parent": 157,
      "props": {
        "id": {
          "type": "value",
          "value": "CardCourseListUX-FormField-158"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "1"
        }
      },
      "seq": 158,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 159,
      "name": "FormField",
      "parent": 157,
      "props": {
        "id": {
          "type": "value",
          "value": "CardCourseListUX-FormField-159"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "6"
        }
      },
      "seq": 164,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 160,
      "name": "FormField",
      "parent": 88,
      "props": {
        "id": {
          "type": "value",
          "value": "CardCourseListUX-FormField-160"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "1"
        }
      },
      "seq": 110,
      "void": false
    },
    {
      "from": null,
      "id": 162,
      "name": "label",
      "parent": 158,
      "props": {
        "children": {
          "type": "value",
          "value": "ผู้เข้าร่วม:",
          "valueEN": "Participant:"
        },
        "id": {
          "type": "value",
          "value": "CardCourseListUX-label-162"
        }
      },
      "seq": 162,
      "void": false
    },
    {
      "from": null,
      "id": 163,
      "name": "div",
      "parent": 159,
      "props": {
        "children": {
          "type": "code",
          "value": "props.employeeSearchBox"
        },
        "id": {
          "type": "value",
          "value": "CardCourseListUX-div-163"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        }
      },
      "seq": 163,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 164,
      "name": "FormField",
      "parent": 157,
      "props": {
        "id": {
          "type": "value",
          "value": "CardCourseListUX-FormField-164"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "2"
        }
      },
      "seq": 159,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 165,
      "name": "FormField",
      "parent": 88,
      "props": {
        "id": {
          "type": "value",
          "value": "CardCourseListUX-FormField-165"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "2"
        }
      },
      "seq": 111,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 166,
      "name": "Radio",
      "parent": 165,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.detail?.participant === \"department\""
        },
        "id": {
          "type": "value",
          "value": "CardCourseListUX-Radio-166"
        },
        "label": {
          "type": "value",
          "value": "Select Department",
          "valueEN": "Select Department"
        },
        "name": {
          "type": "value",
          "value": "participant"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeValue"
        },
        "value": {
          "type": "value",
          "value": "department"
        }
      },
      "seq": 166,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 167,
      "name": "Radio",
      "parent": 164,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.detail?.participant === \"employee\""
        },
        "disabled": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardCourseListUX-Radio-167"
        },
        "label": {
          "type": "value",
          "value": "Select Employee",
          "valueEN": "Select Employee"
        },
        "name": {
          "type": "value",
          "value": "participant"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeValue"
        },
        "value": {
          "type": "value",
          "value": "employee"
        }
      },
      "seq": 167,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 168,
      "name": "Dropdown",
      "parent": 110,
      "props": {
        "disabled": {
          "type": "code",
          "value": "!props.enabledParticipant || props.detail?.participant !== \"department\""
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardCourseListUX-Dropdown-168"
        },
        "name": {
          "type": "value",
          "value": "division"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeValue"
        },
        "options": {
          "type": "code",
          "value": "props.divisionOptions"
        },
        "placeholder": {
          "type": "value",
          "value": "Select Department"
        },
        "search": {
          "type": "code",
          "value": "true"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        },
        "value": {
          "type": "code",
          "value": "props.detail?.division ?? \"\""
        }
      },
      "seq": 168,
      "void": false
    },
    {
      "from": null,
      "id": 169,
      "name": "div",
      "parent": 111,
      "props": {
        "children": {
          "type": "code",
          "value": "props.buttonAdd"
        },
        "id": {
          "type": "value",
          "value": "CardCourseListUX-div-169"
        }
      },
      "seq": 169,
      "void": false
    }
  ],
  "forwardRef": false,
  "height": 80,
  "isMounted": false,
  "memo": false,
  "name": "CardCourseListUX",
  "project": "IsHealth",
  "screenPropsDefault": {
    "cannotPay": false,
    "cashAmountText": "14",
    "citizenID": "31020000552",
    "oweText": 123,
    "patientNameAndHN": "HN: xxxxx นายทดสอบ",
    "sumAmount": {
      "price": 100,
      "reimbursable": 42
    }
  },
  "width": 75
}

*********************************************************************************** */
